import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { selectMasterSlave } from 'common/Components/MasterSlave/controllers/actions';
// this is used instead of the hook version because it provides a more direct access to the redux store,
// which is relevant here
import { IsFeatureSupported } from 'common/Components/FeaturesRestriction/controllers/actions';
import { eClientFeaturePermissions } from 'common/Components/FeaturesRestriction/Enums/eClientFeaturePermissions';

const hrefHomeGlobal = '/SitePages/GlobalManage/Alerts';
const hrefHome = '/SitePages/Home';
const alertsPage = '/SitePages/Alerts';

export default function useMasterSlave() {
  const [masterSlaveList, setMasterSlaveList] = useState<any[]>([]);
  const [loggedClient, setLoggedClient] = useState<string>();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isPowerUser, isGlobalMode } = useSelector((state: RootState) => state.user.loggedUser);
  const ms = useSelector((state: RootState) => state.masterSlave.masterSlave);

  useEffect(() => {
    const masterSlaveObject = ms ?? {};
    const isMasterServer = masterSlaveObject.IsMasterServer;
    const isMaster = masterSlaveObject.IsMaster;
    const slaveList = masterSlaveObject.SlaveDetails ? masterSlaveObject.SlaveDetails : [];
    let showMasterSlave = isMasterServer && ((isMaster && slaveList.length > 0) || !isMaster);
    if (!isPowerUser && isGlobalMode) {
      showMasterSlave = slaveList.length > 1;
    }
    if (showMasterSlave) {
      const masterServerName = isGlobalMode ? 'All' : 'Master';

      const client =
        masterSlaveObject.CurrentyLoggedClient.length === 0 ? masterServerName : masterSlaveObject.CurrentyLoggedClient;
      const slavesListSorted = [...slaveList].sort((a: any, b: any) => a.Name.localeCompare(b.Name));
      const msList = [{ Name: masterServerName }, ...slavesListSorted];
      setMasterSlaveList(msList);
      setLoggedClient(client);
    }
  }, [isGlobalMode, isPowerUser, ms]);

  const onSelectMasterSlave = async (slave: any) => {
    if (slave.Name === loggedClient) return;

    const isMaster = slave.Name === (isGlobalMode ? 'All' : 'Master');
    const slaveReq = isMaster ? null : slave;

    await dispatch(selectMasterSlave(isMaster, slaveReq, isGlobalMode));

    const redirectToGlobal = isGlobalMode && slave.Name === 'All';
    const initialRoute = redirectToGlobal
      ? hrefHomeGlobal
      : IsFeatureSupported(eClientFeaturePermissions.MitreHideOverviewAndReportsPages.value)
      ? alertsPage
      : hrefHome;

    navigate(initialRoute);
  };

  return { masterSlaveList, loggedClient, onSelectMasterSlave };
}
